interface ISiteElementTimerConfig {
    action: IActionType;
    time: number;
}

class SiteElementTimer
    extends QueryElement<HTMLElement> {
    
    private _card: ISiteCard;
    private _config: ISiteElementTimerConfig;

    constructor(card: ISiteCard, element: HTMLElement) {
        super(element, false);

        let path = this.getAttr('data-path');

        this._card = card;
        this._config = card.Model.get((path && SiteModel.split(path)) || []) as ISiteElementTimerConfig;

        let action = SiteAction.create(this._card, this._config.action);
        window.setTimeout(() => { action && action.execute() }, this._config.time);

        this.remove();
    }
}